var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRaisedHand = function SvgRaisedHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.917 3.208v8.709a.917.917 0 001.833 0V4.833c0-.097.168-.25.458-.25.29 0 .459.153.459.25v7.084a.917.917 0 001.833 0V6.875a.458.458 0 11.917 0v6.913c-.25 2.552-2.425 4.545-5.042 4.545a5.037 5.037 0 01-4.205-2.258l-.003.001-3.495-5.255c-.168-.24-.117-.526.09-.671a.458.458 0 01.638.112l1.173 1.753h-.001a.917.917 0 001.676-.482h.002V5.043a.458.458 0 01.917-.001V11.918a.917.917 0 001.833 0V3.208a.458.458 0 11.917 0zm7.317 10.56l.016-.008V6.876a2.292 2.292 0 00-2.76-2.244c-.112-1.055-1.091-1.881-2.282-1.881-.17 0-.335.017-.495.049a2.292 2.292 0 00-4.51.004 2.292 2.292 0 00-2.786 2.238v3.663a2.293 2.293 0 00-3.27 3.135l3.302 4.94a6.875 6.875 0 0012.785-3.01z"
  })));
};

export default SvgRaisedHand;